import { useMutation } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';

import {
  InsurancePaymentIntentCreateResponse,
  InsurancePaymentIntentRequest,
  InsurancePaymentIntentError,
} from '@/types/insurance';
import { API } from '@/utils/apiConstants';

const CREATE_OR_RETRIEVE_PAYMENT_INTENT_KEY = 'createOrRetrievePaymentIntent';

const createOrRetrievePaymentIntent = async (
  data: InsurancePaymentIntentRequest,
): Promise<InsurancePaymentIntentCreateResponse> => {
  const response = await axios.post<InsurancePaymentIntentCreateResponse>(
    `${API.baseEndpoint}/api/v1/buyer_insurance/offer_on_tracking/payment_intent/create_or_retrieve`,
    data,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return response.data;
};

export const useCreateOrRetrievePaymentIntent = () => {
  return useMutation<
    InsurancePaymentIntentCreateResponse,
    AxiosError<InsurancePaymentIntentError>,
    InsurancePaymentIntentRequest
  >({
    mutationKey: [CREATE_OR_RETRIEVE_PAYMENT_INTENT_KEY],
    mutationFn: createOrRetrievePaymentIntent,
  });
};
